import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CustomButton from "../../../ui/button/Button";
import SelectAutoComplete from "../../../ui/selectAutoComplete/SelectAutoComplete";
import { useState } from "react";

const SelectorDeCategoriaModal = ({ open, onClose, onConfirm, categorías }) => {
  const [selectedCategoria, setSelectedCategoria] = useState(null);

  const handleConfirm = () => {
    onConfirm(selectedCategoria);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Selecciona una categoría</DialogTitle>
      <DialogContent style={{ minHeight: "150px" }}>
        <SelectAutoComplete
          field="id"
          fieldC="nombre"
          options={categorías || []}
          value={selectedCategoria || null}
          onChange={(e, value) => setSelectedCategoria(value)}
          placeholder="--Selecciona comentario--"
          size="small"
        />
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={onClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Aceptar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default SelectorDeCategoriaModal;
